import FormCheckboxRadio from 'components/common/FormCheckboxRadio';
import {
  FX_ADD_TRANSACTION_UPLOAD_ID_DRIVER_LICENCE_FRONT_NAME,
  FX_ADD_TRANSACTION_UPLOAD_ID_DRIVER_LICENCE_SWITCH,
  FX_ADD_TRANSACTION_UPLOAD_ID_PASSPORT_NAME,
} from 'constants/fx';
import { Fade } from 'helpers/animation';
import useLang from 'hooks/useLang';
import Form from 'react-bootstrap/Form';
import styled from 'styled-components';

const FormInputDocumentUploadSwitch = ({ information, setInformation }) => {
  const { t } = useLang();

  const { isDriverLicenceSelected } = information;

  const handleChangeDocumentUpload = (e, docType) => {
    e.preventDefault();
    e.stopPropagation();

    let newInformation = {
      ...information,
      isDriverLicenceSelected: !isDriverLicenceSelected,
    };

    if (docType === 'D') {
      newInformation = {
        ...newInformation,
        [FX_ADD_TRANSACTION_UPLOAD_ID_PASSPORT_NAME]: null,
      };
    }

    if (docType === 'P') {
      newInformation = {
        ...newInformation,
        [FX_ADD_TRANSACTION_UPLOAD_ID_DRIVER_LICENCE_FRONT_NAME]: null,
      };
    }

    setInformation(newInformation);
  };

  const renderFormCheckRadio1 = () => {
    const formCheckRadioClassName1 =
      FX_ADD_TRANSACTION_UPLOAD_ID_DRIVER_LICENCE_SWITCH + '1';

    return (
      <>
        <FormCheckboxRadio
          name={FX_ADD_TRANSACTION_UPLOAD_ID_DRIVER_LICENCE_SWITCH}
          className={`${formCheckRadioClassName1} ${
            isDriverLicenceSelected && 'active'
          }`}
          label={t('button_driver_licence')}
          isChecked={isDriverLicenceSelected}
          onClick={(e) => handleChangeDocumentUpload(e, 'D')}
          styles={{ marginRight: '16px' }}
        />
      </>
    );
  };

  const renderFormCheckRadio2 = () => {
    const formCheckRadioClassName2 =
      FX_ADD_TRANSACTION_UPLOAD_ID_DRIVER_LICENCE_SWITCH + '2';

    return (
      <>
        <FormCheckboxRadio
          name={FX_ADD_TRANSACTION_UPLOAD_ID_DRIVER_LICENCE_SWITCH}
          className={`${formCheckRadioClassName2} ${
            !isDriverLicenceSelected && 'active'
          }`}
          label={t('button_passport')}
          isChecked={!isDriverLicenceSelected}
          onClick={(e) => handleChangeDocumentUpload(e, 'P')}
          styles={{ marginRight: '0px' }}
        />
      </>
    );
  };

  return (
    <FormGroupStyled>
      {renderFormCheckRadio1()}
      {renderFormCheckRadio2()}
    </FormGroupStyled>
  );
};

const FormGroupStyled = styled(Form.Group)`
  margin-bottom: 16px;
  position: relative;
  ${Fade};

  img {
    width: 100%;
    height: 230px;
    object-fit: contain;
    border-radius: 12px;
  }
`;

export default FormInputDocumentUploadSwitch;
